enum TimelineEntryType {
  TRANSACTION = 1,
  SESSION,
  ISSUE,
}

export default TimelineEntryType
